<template>
<!--  开户推荐人-->
  <div class="reference-wrap">
    <div class="ipt-box">
      <Field :label="$t('openReference.ipt_label')"
             maxlength="100"
             rows="1"
             type="textarea"
             autosize
             v-model="recommended_by"
             input-align="right"
             :placeholder="$t('openReference.ipt_plh')"
             label-width="auto" />
    </div>
    <div class="btn-box">
      <div class="btn" :class="{dis: isLoading}" @click="next">{{ $t("common.next_step") }}</div>
    </div>
  </div>
</template>
<script>
import { Field, Toast } from "vant";
export default {
  components: {
    Field
  },
  created() {
    this.$query = this.$route.query;
  },
  data() {
    return {
      isLoading: false,
      recommended_by: ""
    };
  },
  methods: {
    next() {
      this.isLoading = true;
      this.toast = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const { recommended_by } = this;
      const { name } = this.$query;
      let request = this.$apis.accountSaveRecommendApi;
      if(name === "InstitutionalOpen"){
        request = this.$apis.companySaveRecommendApi
      }
      request({
        recommended_by
      })
        .then(() => {
          this.$router.push({
            name
          }).finally(()=>{
            this.isLoading = false;
            this.toast.clear();
          });
        }).catch(()=>{
        this.isLoading = false;
        this.toast.clear();
      });
    }
  }
};
</script>

<style scoped lang="less">
  .black-theme{
    .reference-wrap{
      .ipt-box{
        background: none;
        color: #fff;
        border-bottom: #fff solid 1px;
        /deep/ .van-field__control, /deep/ .van-cell__title{
          color: #fff;
        }
      }
    }
  }
  .reference-wrap{
    .ipt-box{
      background: #fff;
      padding: 0 20px;
      /deep/ .van-cell{
        align-items: flex-start;
        min-height: 48px;
        padding: 20px 0;
        .van-field__word-limit{
          color: #999;
        }
      }
    }
    .btn-box{
      padding: 40px 50px;
      .btn{
        height: 100px;
        border-radius: 4px;
        font-size: 32px;
        text-align: center;
        line-height: 100px;
        color: #fff;
        background-color: #1c0955;
        border: #1c0955 1px solid;
        box-shadow: 0 3px 8px 0 rgba(0, 24, 112, 0.15);
        &.dis{
          opacity: 0.6;
        }
      }
    }
  }
</style>
